var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.35 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53,17.9a1,1,0,0,0,.61-.21,1,1,0,0,0,.19-1.4A8.8,8.8,0,0,1,8.51,15,7.37,7.37,0,0,1,15,10.75a4.82,4.82,0,0,1,.77.05,1,1,0,0,0,.26-2,8.64,8.64,0,0,0-1-.06c-6.08,0-8.41,5.64-8.51,5.88L6.33,15l.14.37A10.37,10.37,0,0,0,7.73,17.5,1,1,0,0,0,8.53,17.9Z",
    transform: "translate(-6.33 -6.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.46,14.56a12.84,12.84,0,0,0-2.95-3.67l2.68-2.68a1,1,0,0,0,0-1.42,1,1,0,0,0-1.41,0l-15,15a1,1,0,0,0,0,1.42,1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29l2.88-2.89a8.57,8.57,0,0,0,3.91.93c5.57,0,8.36-5.57,8.48-5.81l.21-.44Zm-7.32.7a1.2,1.2,0,0,1-.9.9Zm-1.16,4a6.8,6.8,0,0,1-2.39-.44l.95-1a3.13,3.13,0,0,0,1.44.36,3.2,3.2,0,0,0,2.86-4.65l1.25-1.26A10.75,10.75,0,0,1,21.41,15C20.7,16.17,18.49,19.25,15,19.25Z",
    transform: "translate(-6.33 -6.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hide-icon.6756d5a5b6ff286bb4e715312077cbd7.svg";
export { ForwardRef as ReactComponent };